export enum SourceCodeGenerateTypes {
  render = 1,
  generateClientCode = 4
}
